<template>
  <div class="login-container">
    <el-dialog :visible.sync="phoneDialogVisible" width="500PX" :close-on-click-modal="false">
      <!-- 登录 -->
      <div class="m-login" v-if="isShowChangePwd == false">
        <ul class="m-tab">
          <li
            class="m-item"
            v-for="(item, index) in loginTypeOpt"
            :key="index"
            :class="{ 'z-active': item.value == checkLoginType }"
          >
            {{ item.label }}
          </li>
        </ul>
        <div class="phone-box">
          <span>+86</span>
          <i class="iconfont-icon icon-xiasanjiaoxing"></i>
          <el-input class="phone-input" v-model="phoneNum" placeholder="请输入手机号码"></el-input>
        </div>
        <!-- 密码登录 -->
        <el-input
          v-if="checkLoginType == 1"
          type="password"
          class="u-input "
          v-model="pass"
          placeholder="请输入密码"
        ></el-input>
        <!-- 验证码登录 -->
        <div class="code-box" v-if="checkLoginType == 2">
          <el-input class="code-input" v-model="codeNum" placeholder="请输入短信验证码"></el-input>
          <div class="code-button" @click="getCode">{{ codeText }}</div>
        </div>
        <div class="m-fuck" v-if="checkLoginType == 1">
          <span></span>
          <span @click="handleForgetPass" class="t-1">忘记密码？</span>
        </div>
        <div class="tip" v-if="checkLoginType == 2">未注册手机验证后自动登录</div>
        <div class="confirm-button" @click="login()">确认</div>
        <el-checkbox v-model="isAgree">
          请阅读并你同意
          <span>《用户协议》</span>和
          <span>《隐私保护指引》</span>
        </el-checkbox>
        <div v-if="checkLoginType == 1" class="m-fuck2" @click="checkLoginType = 2">首次注册登录</div>
        <div v-if="checkLoginType == 2" class="m-fuck2" @click="checkLoginType = 1">返回密码登录</div>
        <!-- <div class="wx-img" :style="{ backgroundImage: 'url( ' + wxImg + ')' }" @click="wxLogin()"></div> -->
      </div>

      <!-- 修改密码 -->
      <div class="m-pwd" v-else>
        <div class="m-title">请设置你的密码</div>
        <el-input type="password" class="u-input" v-model="pwdForm.pass" placeholder="请输入密码"></el-input>
        <el-input type="password" class="u-input" v-model="pwdForm.rePass" placeholder="再次输入密码"></el-input>
        <div class="m-btn f-center" @click="handleConfirmPwd">确认</div>
      </div>
    </el-dialog>

    <!-- 微信登录 -->
    <el-dialog width="340PX" :visible.sync="wxDialogVisible">
      <div class="login-title">微信登录</div>
      <div class="wx-code" :style="{ backgroundImage: 'url( ' + wxCode + ')' }"></div>
      <div class="wx-text">
        切换手机账号登录？
        <span @click="phoneLogin()">登录</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wximg from "@/assets/img/wx_icon.png";
import api from "../api/api";
import { apiCollection, apiResource, apiFormSubmit, apiDelete, apiPut } from "../api/index";
export default {
  name: "login",
  data() {
    return {
      phoneDialogVisible: true,
      codeText: "获取验证码",
      isAgree: false,
      wxImg: wximg,
      wxDialogVisible: false,
      wxCode: "",
      phoneNum: "",
      codeNum: "",
      pass: "", // 密码
      num: 60,
      isButton: false,

      // 是否显示完善密码
      isShowChangePwd: false,
      pwdForm: {
        pass: "",
        rePass: "",
      },

      // 登录方式
      loginTypeOpt: [
        { label: "账号登录", value: 1 },
        // { label: "验证码登录", value: 2 },
      ],
      // 当前登录方式
      checkLoginType: 1,
    };
  },
  methods: {
    login() {
      if (this.checkLoginType == 1) return this.passLogin();
      this.mobileLogin();
    },
    handleForgetPass() {
      this.$message.warning("暂不支持密码修改，请联系管理员获取密码!");
    },
    async passLogin() {
      if (!this.phoneNum) return this.$message.warning("请输入手机号!");
      if (!this.pass) return this.$message.warning("请输入密码!");
      if (!this.isAgree) return this.$message.warning("请点击同意用户协议和隐私保护指引！");
      try {
        const res = await api.pwdLogin({ mobile: this.phoneNum, password: this.pass });
        if (!res.result) return this.$message.error(res.message);
        const arr = [apiCollection, apiResource, apiFormSubmit, apiDelete, apiPut];
        arr.forEach((item) => {
          item.defaults.headers["X-Access-Token"] = res.result.token;
        });
        localStorage.setItem("X-Access-Token", res.result.token);
        this.$message.success("登录成功！");
        this.phoneDialogVisible = false;
        location.reload();
      } catch (err) {
        console.log(err);
      }
    },
    mobileLogin() {
      const params = {
        mobile: this.phoneNum,
        code: this.codeNum,
      };
      if (!this.phoneNum) {
        this.$message.warning("请输入手机号!");
      } else if (!this.codeNum) {
        this.$message.warning("请输入验证码！");
      } else if (!this.isAgree) {
        this.$message.warning("请点击同意用户协议和隐私保护指引！");
      } else {
        api.login(params).then(async (res) => {
          if (res && res.result) {
            const arr = [apiCollection, apiResource, apiFormSubmit, apiDelete, apiPut];
            arr.forEach((item) => {
              item.defaults.headers["X-Access-Token"] = res.result.token;
            });
            localStorage.setItem("X-Access-Token", res.result.token);

            // 获取密码状态
            const ret = await api.getPwdStatus({ mobile: this.phoneNum });
            if (!ret.result) return;
            if (ret.result.status == 2) {
              this.isShowChangePwd = true;
            } else {
              this.$message.success("登录成功！");
              this.phoneDialogVisible = false;
              location.reload();
            }
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    // 确认修改密码
    async handleConfirmPwd() {
      if (!this.phoneNum) return this.$message.warning("请输入手机号!");
      if (!this.pwdForm.pass) return this.$message.warning("请输入密码!");
      if (this.pwdForm.rePass != this.pwdForm.pass) return this.$message.warning("两次密码不一致!");
      const ret = await api.pwdLogin({ mobile: this.phoneNum, password: this.pwdForm.pass });
      if (!ret.result) return;
      this.$message.success("登录成功！");
      this.phoneDialogVisible = false;
      location.reload();
    },
    getCode() {
      if (this.isButton) {
        return;
      }
      if (!this.phoneNum) {
        this.$message.warning("请输入手机号!");
      } else {
        this.getyzm();
        const params = {
          mobile: this.phoneNum,
        };
        api.sendCode(params).then((res) => {
          console.log(res);
          if (res.result) {
            this.$message.success("发送成功！");
          } else {
            this.$message.warning("发送失败！");
          }
        });
      }
    },
    getyzm() {
      this.isButton = true;
      let i = 60;
      let timer = setInterval(() => {
        this.codeText = i + "s";
        i--;
        if (i < 0) {
          this.isButton = false;
          this.codeText = "获取验证码";
          clearInterval(timer);
        }
      }, 1000);
    },
    wxLogin() {
      this.wxDialogVisible = true;
    },
    phoneLogin() {
      this.wxDialogVisible = false;
      this.phoneDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  .login-title {
    padding-bottom: 22px;
    font-size: 26px;
    color: #151515;
    text-align: center;
    font-weight: 600;
  }
  .phone-box {
    display: flex;
    padding: 0 20px;
    margin-bottom: 22px;
    font-size: 16px;
    color: #151515;
    font-weight: bold;
    line-height: 52px;
    border-radius: 6px;
    border: 1px solid #dadde0;
    .iconfont-icon {
      padding-left: 10px;
      line-height: 50px;
    }
  }
  .code-box {
    display: flex;
    margin-bottom: 8px;
    font-size: 16px;
    .code-input {
      flex: 1;
      margin-right: 12px;
    }
    .code-button {
      width: 118px;
      color: #f1a475;
      text-align: center;
      border-radius: 6px;
      border: 1px solid #dadde0;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .tip {
    padding-bottom: 30px;
    font-size: 12px;
    color: #c1c1c1;
  }
  .m-fuck {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .t-1 {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .m-fuck2 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
  }
  .confirm-button {
    margin-bottom: 12px;
    font-size: 16px;
    color: #ffffff;
    line-height: 54px;
    text-align: center;
    background: #f1a475;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .wx-img {
    width: 54px;
    height: 54px;
    margin: 0 auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
  .wx-code {
    width: 100%;
    height: 208px;
    margin: 0 auto 8px;
    background-color: #c1c1c1;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .wx-text {
    color: #151515;
    text-align: center;
    span {
      color: #f1a475;
      cursor: pointer;
    }
  }
  /deep/ {
    .phone-input {
      flex: 1;
      margin-left: 20px;
      .el-input__inner {
        border: none;
      }
    }
    .code-input {
      .el-input__inner {
        height: 52px;
        line-height: 52px;
      }
    }
    .u-input {
      .el-input__inner {
        height: 52px;
        line-height: 52px;
      }
    }
    .el-dialog {
      border-radius: 10px;
    }
    .el-dialog__body {
      padding: 28px 62px 38px;
    }
    .el-checkbox__inner {
      width: 16px;
      height: 16px;
      border-radius: 50%;

      border-color: #f1a475;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #f1a475;
    }
    .el-checkbox__inner::after {
      top: 2px;
      left: 5px;
    }
    .el-checkbox__label {
      color: #c1c1c1;
      word-wrap: break-word;
      span {
        color: #f1a475;
      }
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #c1c1c1;
      span {
        color: #f1a475;
      }
    }
    .el-checkbox {
      margin-bottom: 20px;
    }
  }
}

.m-login {
  .m-tab {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    .m-item {
      font-weight: 400;
      font-size: 24px;
      color: #666666;
      line-height: 33px;
      padding-bottom: 10px;
      margin-right: 14px;
      position: relative;
      cursor: pointer;
      // &.z-active {
      //   color: #f1a373;
      //   &::after {
      //     position: absolute;
      //     bottom: 0;
      //     left: 50%;
      //     transform: translateX(-50%);
      //     content: "";
      //     width: 55px;
      //     height: 3px;
      //     background: #f1a373;
      //   }
      // }
    }
  }
  .u-input {
    margin-bottom: 10px;
  }
}

.m-pwd {
  .m-title {
    font-weight: 500;
    font-size: 20px;
    color: #151515;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .u-input {
    margin-bottom: 12px;
  }
  .m-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    background: #f1a475;
    border-radius: 6px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue